<template>
  <div>
    <div class="block-session-expired">
      <!-- Render Button to open the Dialog -->
      <ejs-dialog  id="footerDialog" ref="footerDialog" :visible='visible && !isDeleting' :isModal='isModal' :header='header' :width='width' :buttons='buttons' :content='content'>
      </ejs-dialog>
      <ejs-dialog  id="footerDialog" ref="footerDialog" :visible='visible && isDeleting' :isModal='isModal'  :width='width' :header='header' :content='contentDeleting'>
      </ejs-dialog>

    </div>
  </div>
</template>
<script>

export default {
  data: function() {
    return {
      width: '500px',
      header: 'Eliminar Cumplimiento/Deber',
      content: 'Esta acción no se podrá deshacer. Se validará si sobre este Cumplimiento/Deber existe alguna información histórica cargada (evidencias y observaciones). Si no hay se eliminará definitivamente.',
      isModal: true,
      contentDeleting: 'Eliminando...',
      buttons: [
        { click: this.deleteInServer,
          buttonModel: {
          content: 'Eliminar', isPrimary: true, disabled: this.isDeleting
        }},
        { click: this.cancel,
          buttonModel: {
          content: 'Cancelar'
        }}
      ]
    }
  },
  mounted: function(){
    this.$store.dispatch('moduleCompliance/resetAll');
  },
  computed:{
    visible(){
      return this.$store.getters['moduleCompliance/getWantToDelete'];
    },
    isDeleting(){
      return this.$store.getters['moduleCompliance/getIsDeletingInServer'];
    },
  },
  methods: {
    deleteInServer(){
      console.log('eliminar');
      this.$store.dispatch('moduleCompliance/deleteComplianceOnServer');
    },
    cancel(){
      this.$store.dispatch('moduleCompliance/resetAll');
    }
  }
}
</script>